var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend-wrapper"},[_c('div',{staticClass:"legend-title"},[_vm._v("Model Predictions")]),_vm._l((_vm.legendItems),function(item,index){return _c('div',{key:index,staticClass:"race-state",style:('background-color: ' + item.color)},[_c('span',{style:(`color: ${item.textColor};`)},[_vm._v(_vm._s(item.state))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }